import * as React from 'react';

const ForsiaInstagramIcon = ({
  height = 32,
  width = 32,
}: {
  height: number;
  width: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_14134_53119)">
      <path
        d="M22 0H10C4.47715 0 0 4.47715 0 10V22C0 27.5228 4.47715 32 10 32H22C27.5228 32 32 27.5228 32 22V10C32 4.47715 27.5228 0 22 0Z"
        fill="#C5E86C"
      />
      <path
        d="M16 8.62C18.4 8.62 18.69 8.62 19.64 8.67C22.08 8.78 23.22 9.94 23.33 12.36C23.37 13.31 23.38 13.59 23.38 16C23.38 18.41 23.38 18.69 23.33 19.64C23.22 22.06 22.08 23.22 19.64 23.33C18.69 23.37 18.41 23.38 16 23.38C13.59 23.38 13.31 23.38 12.36 23.33C9.92 23.22 8.78 22.06 8.67 19.64C8.63 18.69 8.62 18.41 8.62 16C8.62 13.59 8.62 13.31 8.67 12.36C8.78 9.94 9.92 8.78 12.36 8.67C13.31 8.63 13.59 8.62 16 8.62ZM16 7C13.56 7 13.25 7.01 12.29 7.05C9.02 7.2 7.2 9.01 7.05 12.29C7.01 13.25 7 13.56 7 16C7 18.44 7.01 18.75 7.05 19.71C7.2 22.98 9.01 24.8 12.29 24.94C13.25 24.98 13.56 24.99 16 24.99C18.44 24.99 18.75 24.98 19.71 24.94C22.98 24.79 24.8 22.98 24.94 19.71C24.98 18.75 24.99 18.44 24.99 16C24.99 13.56 24.98 13.25 24.94 12.29C24.79 9.02 22.98 7.2 19.71 7.05C18.75 7.01 18.44 7 16 7ZM16 11.38C13.45 11.38 11.38 13.45 11.38 16C11.38 18.55 13.45 20.62 16 20.62C18.55 20.62 20.62 18.55 20.62 16C20.62 13.45 18.55 11.38 16 11.38ZM16 19C14.34 19 13 17.66 13 16C13 14.34 14.34 13 16 13C17.66 13 19 14.34 19 16C19 17.66 17.66 19 16 19ZM20.8 10.12C20.2 10.12 19.72 10.6 19.72 11.2C19.72 11.8 20.2 12.28 20.8 12.28C21.4 12.28 21.88 11.8 21.88 11.2C21.88 10.6 21.4 10.12 20.8 10.12Z"
        fill="#04330F"
      />
    </g>
    <defs>
      <clipPath id="clip0_14134_53119">
        <rect width={width} height={height} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ForsiaInstagramIcon;
